/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillCreateRespVo } from './BillCreateRespVo';
import {
    BillCreateRespVoFromJSON,
    BillCreateRespVoFromJSONTyped,
    BillCreateRespVoToJSON,
    BillCreateRespVoToJSONTyped,
} from './BillCreateRespVo';

/**
 * 
 * @export
 * @interface ResponseBillCreateRespVo
 */
export interface ResponseBillCreateRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseBillCreateRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseBillCreateRespVo
     */
    message?: string;
    /**
     * 
     * @type {BillCreateRespVo}
     * @memberof ResponseBillCreateRespVo
     */
    data?: BillCreateRespVo;
}

/**
 * Check if a given object implements the ResponseBillCreateRespVo interface.
 */
export function instanceOfResponseBillCreateRespVo(value: object): value is ResponseBillCreateRespVo {
    return true;
}

export function ResponseBillCreateRespVoFromJSON(json: any): ResponseBillCreateRespVo {
    return ResponseBillCreateRespVoFromJSONTyped(json, false);
}

export function ResponseBillCreateRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseBillCreateRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : BillCreateRespVoFromJSON(json['data']),
    };
}

export function ResponseBillCreateRespVoToJSON(json: any): ResponseBillCreateRespVo {
    return ResponseBillCreateRespVoToJSONTyped(json, false);
}

export function ResponseBillCreateRespVoToJSONTyped(value?: ResponseBillCreateRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': BillCreateRespVoToJSON(value['data']),
    };
}

